import * as React from 'react';
import './locationSelector.module.scss';
import { SheLocation } from '../../../../mainv3/types/location';
import { LocationId } from '../../../../commonv3/types/locations';
import { CheckBoxSelectInput } from './CheckBoxSelectInput';
import { LocationType } from '../../../../adminv3/types/locations';

type IdSelector = { type: 'id'; value: LocationId };
type LocationTypeSelector = { type: 'location_type'; value: LocationType };
export type LocationFilter = IdSelector | LocationTypeSelector;

type Props = {
    locations: SheLocation[];
    homeLocationId: number;
    showOnline?: boolean;
    showOnlineFirst?: boolean;
    showOther?: boolean;
    isHomeLocationSet: boolean;
    locationSelectors: LocationFilter[];
    onChange: (values: LocationFilter[]) => any;
};

export function getLocationFilter(selector: LocationFilter) {
    switch (selector.type) {
        case 'id': {
            return (l) => (l.location ? l.location.id == selector.value : selector.value == null);
        }
        case 'location_type':
            return (l) => l.location && l.location.location_type == selector.value;
    }
    return null;
}

function getLocationLabel(location, homeLocationId, isHomeLocationSet) {
    const label = location.short_name || location.name;
    return isHomeLocationSet && location.id === homeLocationId ? `ホーム拠点(${label})` : label;
}

export function getOnlineSelector(): IdSelector {
    return { type: 'id', value: null };
}

export function getLocationSelector(locationId: LocationId): IdSelector {
    return { type: 'id', value: locationId };
}

export function getOnlineOption() {
    return { label: 'オンライン', value: getOnlineSelector(), valueForAttribute: 'online' };
}

function getLocationOptions(locations, homeLocationId, isHomeLocationSet) {
    return locations.filter((l) => l.location_type == LocationType.OFFICIAL_BASE).map((l) => ({
        label: getLocationLabel(l, homeLocationId, isHomeLocationSet),
        value: getLocationSelector(l.id),
        valueForAttribute: String(l.id),
    }));
}

function getOtherOption() {
    return { label: 'その他', value: { type: 'location_type', value: LocationType.TEMPORARY } };
}

export function getOptions(
    locations,
    {
        showOnline = true,
        showOnlineFirst = false,
        showOther = true,
        homeLocationId,
        isHomeLocationSet,
    }: {
        showOnline: boolean;
        showOnlineFirst?: boolean;
        showOther: boolean;
        homeLocationId: number;
        isHomeLocationSet: boolean;
    }
) {
    const options = [];
    if (showOnline && showOnlineFirst) {
        options.push(getOnlineOption());
    }
    options.push(...getLocationOptions(locations, homeLocationId, isHomeLocationSet));
    if (showOnline && !showOnlineFirst) {
        options.push(getOnlineOption());
    }
    if (showOther) {
        options.push(getOtherOption());
    }
    return options;
}

export const LocationSelector = ({
    locations,
    homeLocationId,
    showOnline = true,
    showOnlineFirst = false,
    showOther = true,
    isHomeLocationSet,
    locationSelectors,
    onChange,
}: Props) => {
    return (
        <CheckBoxSelectInput
            widthType="s"
            options={getOptions(locations, {
                showOnline,
                showOther,
                showOnlineFirst,
                homeLocationId,
                isHomeLocationSet,
            })}
            values={locationSelectors}
            className="location-selector"
            onChange={onChange}
        />
    );
};
